import { CalendarDate } from '@internationalized/date'

export function nativeToAriaDate(nativeDate: Date): CalendarDate {
  return new CalendarDate(nativeDate.getFullYear(), nativeDate.getMonth() + 1, nativeDate.getDate())
}

/**
 * Formats a date using Intl.RelativeTimeFormat for recent dates (Today, Yesterday)
 * or falls back to localized date format for older dates.
 *
 * @param date - The date to format
 * @param locale - The locale to use (e.g., 'en', 'de')
 * @returns Formatted date string
 */
export function formatRelativeDate(date: Date, locale?: string): string {
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const targetDate = new Date(date.getFullYear(), date.getMonth(), date.getDate())

  const diffTime = targetDate.getTime() - today.getTime()
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24))

  // Today
  if (diffDays === 0) {
    const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })
    return rtf.format(0, 'day')
  }

  // Yesterday
  if (diffDays === -1) {
    const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })
    return rtf.format(-1, 'day')
  }

  // Older dates: use localized date format
  return formatCalendarDate(date, locale)
}

export function formatCalendarDate(date: Date, locale?: string): string {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date)
}

export function formatObservationTime(observedAt: Date, locale?: string): string {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(observedAt)
}
